import { render, staticRenderFns } from "./ui-input.vue?vue&type=template&id=0dfb66b8&scoped=true&"
import script from "./ui-input.vue?vue&type=script&lang=js&"
export * from "./ui-input.vue?vue&type=script&lang=js&"
import style0 from "./ui-input.vue?vue&type=style&index=0&id=0dfb66b8&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0dfb66b8",
  null
  
)

export default component.exports